// Mock data for photography portfolio

export const photographerInfo = {
  name: "Franziska Daum",
  tagline: "Capturing Moments, Creating Memories",
  bio: "Als passionierte Hobby-Fotografin halte ich die besonderen Momente des Lebens fest. Mit einem Auge für Details und Emotionen kreiere ich Bilder, die Geschichten erzählen. Meine Fotografie verbindet technisches Können mit künstlerischer Vision.",
  email: "kontakt@franziska-photography.de",
  phone: "+49 123 456789",
  location: "Deutschland"
};

export const socialMedia = {
  instagram: "https://www.instagram.com/memories_moments_photos?igsh=MWpic2ZwbGkzeXNodQ==",
  facebook: "https://facebook.com/franziskaphotography",
  pinterest: "https://pinterest.com/franziskaphotos"
};

export const categories = [
  { id: 'all', name: 'Alle', count: 18 },
  { id: 'portraits', name: 'Portraits', count: 6 },
  { id: 'landschaft', name: 'Landschaft', count: 6 },
  { id: 'events', name: 'Events', count: 6 }
];

export const services = [
  {
    id: 1,
    title: "Portrait-Fotografie",
    description: "Professionelle Porträts für Business, Familie oder persönliche Anlässe",
    features: ["Indoor & Outdoor Shootings", "Professionelle Nachbearbeitung", "Digitale Galerie"]
  },
  {
    id: 2,
    title: "Event-Fotografie",
    description: "Festhalten besonderer Momente bei Hochzeiten, Geburtstagen und Events",
    features: ["Ganztägige Begleitung", "Ungestellte Momente", "Schnelle Lieferung"]
  },
  {
    id: 3,
    title: "Landschafts-Fotografie",
    description: "Kunstvolle Naturaufnahmen und Landschaftsbilder für Ihr Zuhause",
    features: ["Fine Art Prints", "Verschiedene Formate", "Limitierte Editionen"]
  }
];

export const galleryImages = [
  // Portraits
  {
    id: 1,
    category: 'portraits',
    title: 'Business Portrait',
    url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80',
    watermarked: true
  },
  {
    id: 2,
    category: 'portraits',
    title: 'Creative Portrait',
    url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80',
    watermarked: true
  },
  {
    id: 3,
    category: 'portraits',
    title: 'Outdoor Portrait',
    url: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80',
    watermarked: true
  },
  {
    id: 4,
    category: 'portraits',
    title: 'Fashion Portrait',
    url: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=400&q=80',
    watermarked: true
  },
  {
    id: 5,
    category: 'portraits',
    title: 'Studio Portrait',
    url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80',
    watermarked: true
  },
  {
    id: 6,
    category: 'portraits',
    title: 'Natural Light',
    url: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&q=80',
    watermarked: true
  },
  // Landschaft
  {
    id: 7,
    category: 'landschaft',
    title: 'Mountain Sunrise',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&q=80',
    watermarked: true
  },
  {
    id: 8,
    category: 'landschaft',
    title: 'Forest Path',
    url: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&q=80',
    watermarked: true
  },
  {
    id: 9,
    category: 'landschaft',
    title: 'Coastal View',
    url: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&q=80',
    watermarked: true
  },
  {
    id: 10,
    category: 'landschaft',
    title: 'Lake Reflection',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&q=80',
    watermarked: true
  },
  {
    id: 11,
    category: 'landschaft',
    title: 'Autumn Colors',
    url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=400&q=80',
    watermarked: true
  },
  {
    id: 12,
    category: 'landschaft',
    title: 'Desert Dunes',
    url: 'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=400&q=80',
    watermarked: true
  },
  // Events
  {
    id: 13,
    category: 'events',
    title: 'Wedding Ceremony',
    url: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=400&q=80',
    watermarked: true
  },
  {
    id: 14,
    category: 'events',
    title: 'Birthday Celebration',
    url: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400&q=80',
    watermarked: true
  },
  {
    id: 15,
    category: 'events',
    title: 'Corporate Event',
    url: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=400&q=80',
    watermarked: true
  },
  {
    id: 16,
    category: 'events',
    title: 'Music Concert',
    url: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=400&q=80',
    watermarked: true
  },
  {
    id: 17,
    category: 'events',
    title: 'Family Gathering',
    url: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=400&q=80',
    watermarked: true
  },
  {
    id: 18,
    category: 'events',
    title: 'Party Night',
    url: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=400&q=80',
    watermarked: true
  }
];

export const featuredImages = [
  galleryImages[0],
  galleryImages[6],
  galleryImages[12]
];
